import React from "react";
import Hero from "../components/dental/Hero";
import Welcome from "../components/dental/Welcome";
import DentalServices from "../components/dental/DentalServices";
import SpaServices from "../components/dental/SpaServices";
import Newsletter from "../components/dental/Newsletter";
import Boutique from "../components/dental/Boutique";

const Home = () => (
  <>
    <Hero />
    {/* <Welcome /> */}
    <DentalServices />
    {/* <SpaServices /> */}
    <Newsletter />
    {/* <Boutique /> */}
  </>
);

export default Home;
